const SOURCE_NAMES = {
  warning: 'Warning',
  benefit: 'Benefit',
  salary: 'Salary',
  contract: 'Contract',
  unpaid_leave: 'Unpaid leave'
}

const ACTION_NAMES = {
  created: 'created',
  updated: 'updated',
  signed: 'signed',
  deleted: 'deleted'
}

function sourceName(source) {
  return SOURCE_NAMES[source] || String(source || '').replace(/_/g, ' ') || 'Data'
}

function actionName(action) {
  return ACTION_NAMES[action] || String(action || 'changed').replace(/_/g, ' ')
}

// "Warning signed" is enough on its own; the backend details add the record id.
function eventTitle(event) {
  if (event && event.details) return event.details
  return `${sourceName(event && event.source)} ${actionName(event && event.action)}`
}

function eventAuthor(event) {
  return (event && event.actor_name) || ''
}

function pendingEvents(payroll) {
  const events = payroll && payroll.pending_recalculation_events
  return Array.isArray(events) ? events : []
}

module.exports = {
  actionName,
  eventAuthor,
  eventTitle,
  pendingEvents,
  sourceName
}
